export const _queryParameterize = (
	paramObj: Lookup<string | number | boolean>,
): string => {
	const keys = Object.keys(paramObj).filter(key => paramObj[key] != undefined)
	if (keys.length === 0) return ''

	const keyValues = keys.map(key => {
		const value = paramObj[key]
		return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
	})

	return '?' + keyValues.join('&')
}
